export default __webpack_public_path__ + "static/media/bg-character-img-1.33349723.png";